var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.997,
    r: 4.267
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.393 15.103c-.25.23-.393.554-.393.893 0 .34.143.664.393.894l4.434 4.065c.274.251.67.317 1.01.168.341-.149.562-.485.563-.856v-8.534c0-.372-.22-.709-.561-.858-.34-.15-.738-.084-1.012.167l-4.434 4.06zM31.606 16.89c.25-.23.394-.554.394-.894 0-.34-.143-.664-.394-.893l-4.433-4.065c-.275-.252-.673-.318-1.014-.167-.341.151-.56.49-.559.862v8.534c0 .372.22.709.56.859.34.15.738.084 1.012-.168l4.434-4.068zM15.107 31.603c.229.251.553.394.893.394.34 0 .664-.143.893-.394l4.065-4.434c.252-.274.318-.671.168-1.012-.15-.34-.487-.56-.86-.56h-8.533c-.371 0-.708.22-.858.56-.15.34-.085.737.166 1.012l4.066 4.434zM16.893.39c-.23-.25-.553-.393-.893-.393-.34 0-.664.142-.893.393l-4.065 4.434c-.251.274-.317.671-.167 1.012.15.34.486.56.858.561h8.534c.372 0 .709-.22.858-.56.15-.342.084-.739-.167-1.013L16.893.39z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.b85b87ef53432a99df987182cb358fdb.svg";
export { ForwardRef as ReactComponent };